import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";
import { Randomnumber } from "../../components_root/rendom_number";
import { number } from "framer-motion";

export const Create_ledger_account = async (data) => {
  const { name, accountguid, account_type } = data || {};

  // Validation
  if (!name?.trim()) {
    return { success: false, error: "Missing name" };
  }
  if (!accountguid?.trim()) {
    return { success: false, error: "Missing accountguid" };
  }
  if (!account_type?.trim()) {
    return { success: false, error: "Missing account_type" };
  }


  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  const servicetablename = "accountingfinancedb";
  try {
    // SAVE AREA
    const tablename = "ledger_accounts";
   
    // Create ledger under company  
    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      tablename,
      accountguid
    );
    const savequery = {
      ...data, 
      companyuid: select_company_uid,
      accountnumber:Randomnumber(8),
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(parentDocRef, savequery);
    return { success: true };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
